import { AnimatePresence, motion } from "framer-motion";
import { Check, Heart } from "lucide-react";
import { DECORATIONS } from "@/lib/data";
import { brl } from "@/lib/pricing";

export const YesNo = ({ value, onChange, testid, yesLabel = "Sim", noLabel = "Não" }) => (
  <div className="inline-flex rounded-full border border-[#d6d0c4] bg-white p-1">
    {[
      [true, yesLabel],
      [false, noLabel],
    ].map(([v, label]) => (
      <button
        key={label}
        type="button"
        data-testid={`${testid}-${v ? "yes" : "no"}`}
        onClick={() => onChange(v)}
        className={`rounded-full px-6 py-2 text-xs font-bold uppercase tracking-[0.18em] transition-colors duration-300 ${
          value === v ? "bg-[#163323] text-[#faf7f2]" : "text-[#163323] hover:bg-[#efe7da]"
        }`}
      >
        {label}
      </button>
    ))}
  </div>
);

const DecoCard = ({ d, on, onPick }) => (
  <button
    type="button"
    data-testid={`romantic-pkg-${d.id}`}
    onClick={onPick}
    className={`group flex flex-col overflow-hidden rounded-sm border bg-white text-left transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-1 ${
      on ? "border-[#8e2a22] shadow-[0_18px_40px_-18px_rgba(142,42,34,0.55)]" : "border-[#e2ded6]"
    }`}
  >
    <div className="relative aspect-[16/10] overflow-hidden">
      <img src={d.image} alt={`Decoração ${d.name}`} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
      <span className="absolute left-3 top-3 rounded-full bg-[#5c1712]/85 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.2em] text-white">{d.option}</span>
      {on && (
        <span className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-[#8e2a22] text-white">
          <Check className="h-4 w-4" />
        </span>
      )}
    </div>
    <div className="flex flex-1 flex-col p-5">
      <div className="flex items-baseline justify-between gap-3">
        <h4 className="text-xl font-bold uppercase tracking-tight text-[#5c1712]">{d.name}</h4>
        <p className="text-lg font-bold text-[#163323]">{brl(d.price)}</p>
      </div>
      <p className="mt-1 text-sm italic text-[#5a6e61]">{d.lead}</p>
      <ul className="mt-4 space-y-2">
        {d.items.map((it) => (
          <li key={it} className="flex gap-2 text-sm text-[#1a241e]">
            <Heart className="mt-0.5 h-3.5 w-3.5 flex-none fill-[#b13a2e] text-[#b13a2e]" />
            {it}
          </li>
        ))}
      </ul>
      <p className="mt-auto pt-4 text-[11px] font-bold uppercase tracking-[0.15em] text-[#8e2a22]">{d.ideal}</p>
    </div>
  </button>
);

export const DecorationPicker = ({ enabled, setEnabled, decoId, setDecoId }) => (
  <div data-testid="romantic-decoration">
    <YesNo
      value={enabled}
      testid="romantic-toggle"
      onChange={(v) => {
        setEnabled(v);
        if (!v) setDecoId(null);
      }}
    />
    <AnimatePresence initial={false}>
      {enabled && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="overflow-hidden"
        >
          <div className="grid gap-4 pt-6 md:grid-cols-3">
            {DECORATIONS.map((d) => (
              <DecoCard key={d.id} d={d} on={decoId === d.id} onPick={() => setDecoId(d.id)} />
            ))}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);
